// Co-Author: Luis Booth - November 2018
// The numbers Mason,
// What do they mean?!

// Validations Rules for forms
// - `true` means it pass the rule
// ==============================================

// Deps =========================================
import React from 'react';
import valid from 'card-validator';

// Local scope ==================================
//== Regular Expresions
export const regex = {
  alpha: /^[A-Za-z]*$/i,
  numeric: /(^$)|^[-+]?(?:\d*[.])?\d+$/,
  points: /(^$)|^\d+$/,
  phone: /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})((?:\[?\d{1,}\]?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
  zipCodeUS: /(^$)|(^[0-9]{5}$)|(^[0-9]{5}-[0-9]{4}$)/,
  zipCodeCA: /(^$)|(^[\w\d]{3} [\w\d]{3}$)|(^[\w\d]{6}$)/,
  alphaNumeric: /^[a-zA-Z0-9\s-]*$/i,
  address: /(^$)|^[^-\s][a-zA-ZÀ-ÿ0-9,-.'`~# \\/ʼ·\s-]+$/i,
  name: /(^$)|^[a-z\u00C0-\u02AB'~`-]+\s?([a-z\u00C0-\u02AB'~`-]+\s?)+$/i,
  middleName: /(^$)|^[a-z\u00C0-\u02AB'~`-]?\s?([a-z\u00C0-\u02AB'~`-]?\s?)+$/i,
  ccName: /(^$)|^[a-z\u00C0-\u02AB'~`-]+\.?\s?([a-z\u00C0-\u02AB'~`-]+\.?\s?)+$/i,
  email: /(^$)|(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@!%*?&#_]).{8,16}$/,
  cvv: /(^$)|^[0-9]{3,4}$/,
  currency: /^(^$)|((\$)( )?)?((\d+)|(\d{1,3})(\,\d{3})*)(\.\d{1,2})?$/,
  ssgUsername: /(^[a-zA-Z0-9-_]*$)|(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/i,
  promoCode: /^[a-zA-Z0-9_]*$/i,
  comments: /(^$)|^[\w\s,.]+$/i,

  // Backend Regex for Vacations
  groupCode: /(^$)|^([a-zA-Z]{2})+[0-9]{8}$/,
  alphaSpaces: /(^$)|[a-zA-Z ]+/,
  beEmail: /(^$)|^([A-Z0-9._%+-]+)@(([A-Z0-9.-]+)(\.[A-Z]{2,6}))$/i,

};
/*  old alphanumeric /^[0-9A-Z]+$/i*/
/* alphaNumeric if is not required /^[a-zA-Z0-9]*$/i */

/* old email regex /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i */
/* new email regex /(^$)|(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/i */

/*  phoneNumber: /^(\d+-?)+\d+$/,
  phone 2: (^$)|^[-+]?(?:\d*[.])?\d+$
*/

// Validations ====================================
const validator = {
  required: {
    validate: value => value.toString().trim() !== '',
    message: 'Required field.',
    hint: () => (<span className="form-error is-visible">Required field.</span>)
  },
  alpha: {
    validate: value => regex.alpha.test(value),
    message: 'Invalid value. Letters only.',
    hint: () => (<span className="form-error is-visible">Invalid value. Letters only.</span>)
  },
  numeric: {
    validate: value => regex.numeric.test(value),
    message: 'Invalid value. Numbers only.',
    hint: () => (<span className="form-error is-visible">Invalid value. Numbers only.</span>)
  },
  points: {
    validate: value => regex.points.test(value),
    message: 'Invalid value. Numbers only.',
    hint: () => (<span className="form-error is-visible">Invalid value. Numbers only.</span>)
  },
  ssgUsername: {
    validate: value => regex.ssgUsername.test(value),
    message: 'Invalid value.',
    hint: () => (<span className="form-error is-visible">Invalid value.</span>)
  },
  promoCode: {
    validate: value => regex.promoCode.test(value),
    message: 'Invalid value.',
    hint: () => (<span className="form-error is-visible">Invalid value.</span>)
  },
  phone: {
    validate: value => regex.phone.test(value),
    message: 'Invalid value. Numbers only.',
    hint: () => (<span className="form-error is-visible">Invalid value. Numbers only.</span>)
  },
  zipCodeUS: {
    validate: value => regex.zipCodeUS.test(value),
    message: 'Invalid Zip Code.',
    hint: () => (<span className="form-error is-visible">Invalid Zip Code.</span>)
  },
  zipCodeCA: {
    validate: value => regex.zipCodeCA.test(value),
    message: 'Invalid Zip Code.',
    hint: () => (<span className="form-error is-visible">Invalid Zip Code.</span>)
  },
  alphaNumeric: {
    validate: value => regex.alphaNumeric.test(value),
    message: 'Invalid value. Only numbers and letters allowed.',
    hint: () => (<span className="form-error is-visible">Invalid value. Only numbers and letters allowed.</span>)
  },
  comments: {
    validate: value => regex.comments.test(value),
    message: 'Invalid value. Only numbers and letters allowed.',
    hint: () => (<span className="form-error is-visible">Invalid value. Only numbers and letters allowed.</span>)
  },
  address: {
    validate: value => regex.address.test(value),
    message: 'Invalid value. Only numbers and letters allowed.',
    hint: () => (<span className="form-error is-visible">Invalid value. Only numbers and letters allowed.</span>)
  },
  amount: {
    validate: value => regex.currency.test(value),
    message: 'Please provide a valid number.',
    hint: () => (<span className="form-error is-visible">Please provide a valid number.</span>)
  },
  name: {
    validate: value => regex.name.test(value),
    message: 'Please provide a valid name.',
    hint: () => (<span className="form-error is-visible">Please provide a valid name.</span>)
  },
  middleName: {
    validate: value => regex.middleName.test(value),
    message: 'Please provide a valid name.',
    hint: () => (<span className="form-error is-visible">Please provide a valid name.</span>)
  },
  email: {
    validate: value => regex.email.test(value),
    message: 'value isn\'t an Email.',
    hint: value => (<span className="form-error is-visible"><b>{value}</b> isn't an Email.</span>)
  },
  ccName: {
    validate: value => regex.ccName.test(value),
    message: 'Please provide a valid name.',
    hint: () => (<span className="form-error is-visible">Please provide a valid name.</span>)
  },
  ccNumber: {
    validate: value => valid.number(value).isValid,
    getCardType: value => valid.number(value),
    message: 'Please provide a valid card number.',
    hint: () => (<span className="form-error is-visible">Please provide a valid card number.</span>)
  },
  ccExp: {
    validate: value => valid.expirationDate(value).isValid,
    message: 'Invalid Date.',
    hint: () => (<span className="form-error is-visible">Invalid <b>Date</b>.</span>)
  },
  cvv: {
    validate: value => regex.cvv.test(value),
    message: 'Please provide a valid CVV ID.',
    hint: () => (<span className="form-error is-visible">Please provide a valid <b>CVV</b>.</span>)
  },
  ccv: {
    validate: (value, components) => {

      const numValidation = valid.number(components.ccNumber.state.value);
      const trimVal = value.replace(/\D/g, '');
      let size = 3;

      if (numValidation.card) {
        size = numValidation.card.code.size;
      }

      return trimVal.length === size;
    },
    message: 'Invalid Credit Card Number',
    hint: (value, components) => {

      const numValidation = valid.number(components.ccNumber.state.value);
      let messageJSX = (<small className="form-error is-visible small">Invalid <b>CCV</b> code.</small>);

      if (numValidation.card) {
        messageJSX = (<small className="form-error is-visible small"><b>{ numValidation.card.code.name }</b> code should be { numValidation.card.code.size } numbers.</small>);
      }

      return messageJSX;
    }
  },

  // Backend Vacation Regex
  groupCode: {
    validate: value => regex.groupCode.test(value),
    message: 'Invalid value.',
    hint: () => (<span className="form-error is-visible">Invalid value.</span>)
  },
  alphaSpaces: {
    validate: value => regex.alphaSpaces.test(value),
    message: 'Invalid value. Letters only.',
    hint: () => (<span className="form-error is-visible">Invalid value. Letters only.</span>)
  },
  beEmail: {
    validate: value => regex.beEmail.test(value),
    message: 'value isn\'t an Email.',
    hint: value => (<span className="form-error is-visible"><b>{value}</b> isn't an Email.</span>)
  },
};

// Export Validator ===========================
export default validator;



// WEBPACK FOOTER //
// ./js/modules/validator.js